<template>
	<div class="menu-delivery-bar">
		<i class="sk-icon-bicycle-solid"></i>
		<div>
			Delivery
			<b class="delivery-detail-when" @click="whenClicked">
				{{ deliveryDetailWhen }}
			</b>
			<span v-if="locationText">to</span>
			<b>{{ locationText }}</b>
		</div>
		<button
			v-if="showVoucherCta"
			@click="couponClicked"
			class="button button-secondary-dark button-auto voucher-button"
		>
			<i class="sk-icon-ticket-alt-solid"></i>
			<span class="text-truncate">{{ voucherButtonText }} applied</span>
			<i v-if="couponCode" class="sk-icon-times" />
		</button>
	</div>
</template>

<style scoped>
.menu-delivery-bar {
	background: var(--gR-base-80);
	width: 100%;
	height: 55px;
	display: flex;
	align-items: center;
	padding: 0 0 0 20px;
}

.menu-delivery-bar,
.menu-delivery-bar div,
.menu-delivery-bar span,
.menu-delivery-bar b {
	color: var(--gR-white);
	font-size: 12px;
}

.menu-delivery-bar b {
	margin: 0 10px;
}

.menu-delivery-bar i {
	font-size: 13px;
	color: var(--gR-white);
	margin-right: 10px;
}

.voucher-button {
	margin-left: auto;
	font-size: 10px;
	align-items: center;
	display: flex;
	padding: 10px 20px;
}

@media (max-width: 400px) {
	.text-truncate {
		max-width: 70px;
	}
}

.voucher-button i {
	font-size: 12px;
	height: 10px;
	display: flex;
	align-items: center;
}

.voucher-button i:first-child {
	margin-right: 10px;
}

.voucher-button .sk-icon-times {
	margin-left: 10px;
}

.delivery-detail-when {
	cursor: pointer;
}
</style>

<script>
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import { BusinessType } from "@reef-os/utils/enums/businessType"
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import moment from "moment"
import locationNameFormatterMixin from "@/mixins/location-name-formatter-mixin"

export default {
	name: "MenuDeliveryBar",
	mixins: [locationNameFormatterMixin],
	computed: {
		deliveryMode() {
			return this.$store.getters.deliveryMode
		},
		businessType() {
			return this.$store.state.business.type
		},
		locationText() {
			if (this.$store.getters.isPopup) {
				return null
			}

			switch (this.deliveryMode) {
				case DeliveryMode.LAST_YARD:
				case DeliveryMode.DIRECT_TO_LOCATION: {
					let table = this.table
					if (table == 0 || table == -1) {
						return null
					}
					if (this.table.toLowerCase && this.table.split) {
						table = this.table
							.toLowerCase()
							.split(/[-\s]/g)
							.map(
								(text) =>
									text.charAt(0).toUpperCase() + text.slice(1)
							)
							.join(" ")
					}
					const location = this.$options.filters.locationName(
						this.businessType
					)
					return location ? `${location} ${table}` : table
				}
				case DeliveryMode.YAY_FOOD_POLE:
					return null
				case DeliveryMode.PICKUP_AREA:
					switch (this.businessType) {
						case BusinessType.BAR:
							return "Pickup Station"
						case BusinessType.HOTEL:
							return "Lobby"
					}
					break
				case DeliveryMode.DIRECT_TO_CUSTOMER:
					return null
			}
			return null
		},
		deliveryDetailWhen() {
			if (this.$store.state.deliveryDate) {
				const formattedDay = moment(
					this.$store.state.deliveryDate.date
				).format("ddd. M/D")
				const formattedTime = moment(
					this.$store.state.deliveryDate.time,
					"HH:mm:ss"
				).format("h:mm A")
				return `${formattedDay} ${formattedTime}`
			} else {
				return "ASAP"
			}
		},
		table() {
			if (
				this.$route.params.table != undefined ||
				this.$store.getters.table != -1
			) {
				return this.$store.state.table
			} else {
				return -1
			}
		},
		preorderOnly() {
			return this.$store.getters.preorderOnly
		},
		couponCode() {
			return this.$store.state.coupon.code
		},
		showVoucherCta() {
			return this.$store.state.showVouchers
		},
		voucherButtonText() {
			return this.$store.state.coupon.id > 0 ? this.couponCode : "Voucher"
		}
	},
	methods: {
		whenClicked() {
			if (this.$store.getters.isPopup) {
				return
			}
			eventBus.emit(EventBusEvents.OPEN_MENU_TIME_MODAL, {
				date: this.$store.state.deliveryDate
			})
		},
		couponClicked() {
			if (this.couponCode) {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Remove Coupon Clicked",
					data: {
						code: this.couponCode
					}
				})
				this.$store.dispatch("removeCoupon")
			} else {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Add Coupon Clicked"
				})
				eventBus.emit(EventBusEvents.OPEN_COUPON_MODAL)
			}
		}
	}
}
</script>